import React from 'react'
import { Box } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import { useOrderMode, ORDER_MODES } from '../../context/OrderMode'
import { BUTTON_RESET, C, FONT_BODY, FOCUS_RING, RADIUS } from '../../utils/designTokens'

// The discovery screens each list one kind of restaurant, so switching mode
// there moves to the other list. Anywhere else (a restaurant's page, checkout)
// the switch only changes the mode: the page stays and its fees follow.
const DISCOVERY_PATHS = ['/', '/restaurant-list', '/pickup']

const DeliveryPickupToggle = ({ compact = false }) => {
  const { orderMode, setOrderMode } = useOrderMode()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const onDiscovery = DISCOVERY_PATHS.includes(pathname)

  const choose = (mode) => {
    setOrderMode(mode)
    if (!onDiscovery) return
    navigate(mode === ORDER_MODES.PICKUP ? '/pickup' : '/restaurant-list')
  }

  const option = (mode, label) => {
    const active = orderMode === mode
    return (
      <Box
        component="button"
        type="button"
        onClick={() => choose(mode)}
        aria-pressed={active}
        sx={{
          ...BUTTON_RESET,
          height: 36,
          px: compact ? '12px' : '16px',
          borderRadius: RADIUS.pill,
          fontFamily: FONT_BODY,
          fontSize: 14,
          fontWeight: 600,
          whiteSpace: 'nowrap',
          backgroundColor: active ? C.red : 'transparent',
          color: active ? '#FFFFFF' : C.ink,
          transition: 'background-color .15s ease, color .15s ease',
          '&:hover': { backgroundColor: active ? C.redHover : C.border },
          ...FOCUS_RING,
        }}
      >
        {label}
      </Box>
    )
  }

  return (
    <Box
      role="group"
      aria-label="Delivery or pickup"
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        height: 44,
        p: '4px',
        boxSizing: 'border-box',
        borderRadius: RADIUS.pill,
        backgroundColor: C.surface2,
      }}
    >
      {option(ORDER_MODES.DELIVERY, 'Delivery')}
      {option(ORDER_MODES.PICKUP, 'Pickup')}
    </Box>
  )
}

export default DeliveryPickupToggle
